import {
  ShippingRestrictionRequestDto,
  DeliveryProvinceRequest,
} from '@tiendanube/common';
import { SelectedZonesInterface } from 'domains/Shipping/components/shared/ZoneManagement/DeliveryZoneCard/DeliveryZoneCard';

export interface ShippingRestrictionFormValues
  extends Omit<ShippingRestrictionRequestDto, 'specificDeliveryZones'> {
  selectedZones?: SelectedZonesInterface[];
}

export function zonesToDto(
  zones: SelectedZonesInterface[],
): DeliveryProvinceRequest[] {
  return zones.map((zone) => ({
    provinceId: zone.provinceCode,
    cities: zone.cities,
    citiesIds:
      zone.cities.length > 0 ? zone.cities.map((c) => c.id) : undefined,
  }));
}

export function zonesFromDto(
  zones: DeliveryProvinceRequest[] | undefined,
): SelectedZonesInterface[] {
  if (!zones || zones.length === 0) return [];

  return zones.map((zone) => ({
    provinceId: '',
    provinceCode: zone.provinceId,
    provinceName: '',
    cities: zone.cities || [],
  }));
}

export function formValuesToDto(
  formValues: ShippingRestrictionFormValues,
): ShippingRestrictionRequestDto {
  const { selectedZones, ...rest } = formValues;

  return {
    ...rest,
    restrictedProducts: rest.restrictedProducts?.map((id) => String(id)),
    specificDeliveryZones: selectedZones
      ? zonesToDto(selectedZones)
      : undefined,
  };
}

export function dtoToFormValues(
  dto: ShippingRestrictionRequestDto,
): ShippingRestrictionFormValues {
  return {
    methodId: dto.methodId,
    shippingMethodsScope: dto.shippingMethodsScope,
    selectedShippingMethods: dto.selectedShippingMethods || [],
    distributionCenterScope: dto.distributionCenterScope,
    specificDistributionCenters: dto.specificDistributionCenters || [],
    deliveryZonesScope: dto.deliveryZonesScope,
    deliveryDistanceInKm: dto.deliveryDistanceInKm,
    productRestrictionType: dto.productRestrictionType,
    restrictedCategories: dto.restrictedCategories || [],
    restrictedProducts: dto.restrictedProducts || [],
    weightRestrictionType: dto.weightRestrictionType,
    cartWeightMin: dto.cartWeightMin,
    cartWeightMax: dto.cartWeightMax,
    valueRestrictionType: dto.valueRestrictionType,
    cartValueMin: dto.cartValueMin,
    cartValueMax: dto.cartValueMax,
    selectedZones: zonesFromDto(dto.specificDeliveryZones),
  };
}
